<script>
import appSlicedText from '../app-sliced-text/index.vue'
import AppCarDetailsPopin from '../app-car-details/index.vue'
import AppCarDetailsPhotos from '../app-car-photos/index.vue'
import AppScrollObject from '../app-scroll-object/index.vue'
import { Carousel, Slide } from 'vue-carousel';
export default {
  name:'app-home-slide',
  props: {
                      debug: {
                          type: Boolean,
                          default: !1
                      },
                     content: {
                         type: Object,
                         default: function() {}
                     },
                     adminContent: {
                         type: Object,
                         default: function() {}
                     },
                     activeIndex: {
                         type: Number,
                         default: 0
                     },
                     indexSS: {
                         type: Number,
                         default: 0
                     },
                     hasVideo: {
                         type: Boolean,
                         default: !1
                     },
                     navOffsetTop: {
                         type: Number,
                         default: 0
                     },
                     headerPageSize: {
                         type: Array,
                         default: function() {}
                     },
                     IsTolltipPopDisabled:{
                       type: Boolean,
                       default: !1
                     }
                 },
                 data: function() {
                     return {
                         isActive: !1,
                         popinContent: null,
                         popinIndex: 0,
                         isPopinActive: !1,
                         isBoardActive: !1,
                         IsActiveCountUp:!1,
                         OfficesVal:0,
                         ClientsVal:0,
                         EmployeesVal:0,
                         isButtonClicked:false,
                         SectorsVal:0,
                         componentKey: 0,
                         imageHeadSrc:require('../../assets/medias/images/Privinvest_homepage_crop-1800x900.jpg')
                     }
                 },
                 computed:{

                   myStylesTransform2() {
                       return {
                           transform: 'translateX('+this.headerPageSize[2]+'px) translateY('+this.headerPageSize[3]+'px) scale('+this.headerPageSize[4]+')'

                       }
                   },
                   myStylesWidthHeight() {
                       return {
                         width: this.headerPageSize[0] + "px",
                         height: this.headerPageSize[1] + "px"

                       }
                   }
                 },
                 components:
                 {
                     "app-sliced-text":appSlicedText,
                     AppScrollObject,
                     Carousel,
                      Slide,
                      'app-car-details':AppCarDetailsPopin,
                      'app-car-photos':AppCarDetailsPhotos,
                 },
                 watch:
                 {
                     activeIndex: "onActiveIndexChange"
                 },
                 created: function()
                 {
                     this._transitionDuration = 1200,
                     this.eventHub.$on("resize", this.onResize),
                     this.eventHub.$on("close:popin", this.onClosePopin)//,
                    // this.$video.play()

                 },
                 destroyed: function ()
                 {
                     this.eventHub.$off("resize", this.onResize),
                     this.eventHub.$off("close:popin", this.onClosePopin)
                 },
                 mounted: function()
                 {
                     //RAthis.hasVideo && (this.$video = this.$el.querySelector(".js-video")),
                     0 === this.indexSS ? this.$el.classList.add("is-active") : this.$el.style.visibility = "hidden",
                     this.$imagesContainer = this.$el.querySelectorAll(".js-photo-container"),
                     this.popinContent=this.content.posts_offer['1'][0]
                 },
                 methods:
                 {
                   forceRerender() {
                   this.componentKey += 1;
                   },
                   onOpenPopinPHOTOS: function (t, e)
                   {
                       this.forceRerender();
                       this.isButtonClicked=true;
                       alert("popin desc");
                       var n = this;
                       this.popinIndex = 0,
                       this.popinContent =   t,
                       this.popinTitle =   t.title,
                       this.eventHub.$emit("disable:scroll"),
                         this.eventHub.$emit("open:popin"),
                       //this.eventHub.$emit("open:popinphotos"),
                       setTimeout(function ()
                       {
                           n.isButtonClicked=false;
                           n.isPopinActivePhotos = !0,
                           //n.$el.classList.add("is-popin-active--photos"),
                           n.$el.classList.add("is-popin-active"),
                           n.onTransition()
                       }, 50)
                   },
                   onOpenPopinSlideOut(item,index)
                   {
                                     this.eventHub.$emit("open:popinslideout");

                                      const panel1Handle =this.$showPanel({
                                      component: 'app-form-buycar',
                                      width: '500px', //customize the width
                                      cssClass: 'panel-1-custom-class', //add a custom CSS class
                                      keepAlive: true,
                                      props:
                                            {
                                                content: item
                                            }
                                      });

                                      panel1Handle.promise
                                      .then(results => {
                                              this.eventHub.$emit("close:popinslideout");
                                      });
                   },
                     onActiveIndexChange: function()
                     {
                       //console.log("Active Index Changed"+this.activeIndex);
                         var t = this;
                         this.activeIndex===2? (this.OfficesVal=1800,
                            this.ClientsVal=1700,
                            this.EmployeesVal=2000,
                            this.SectorsVal=1500,
                            this.IsActiveCountUp=!0):(this.OfficesVal=0,
                               this.ClientsVal=0,
                               this.EmployeesVal=0,
                               this.SectorsVal=0
                               ,this.IsActiveCountUp=!1)
                         this.$el.style.transform = "translateY(" + 100 * -this.activeIndex + "%) translateZ(0)",
                          clearTimeout(this._visibilityTimer),
                          this.indexSS === this.activeIndex
                           ?
                          (this.$el.classList.remove("is-leaving"),
                          setTimeout(function() {   t.$el.classList.add("is-active")   }, 10),
                           this.isActive = !0,
                            this.$el.style.visibility = "visible")
                          :
                          this.isActive
                          &&
                           (this.$el.classList.add("is-leaving"),
                          this.$el.classList.remove("is-active"),
                          this.isActive = !1,
                          this._visibilityTimer = setTimeout(function() {   t.$el.style.visibility = "hidden", t.$el.classList.remove("is-leaving") },
                           this._transitionDuration))//,

                        /*  this.indexSS === this.activeIndex && this.hasVideo
                          ?
                           this.playVideo()
                           :
                           this.indexSS !== this.activeIndex && this.hasVideo && this.pauseVideo()
                           */
                     },
                     playVideo: function() {
                         var t = this;
                         clearTimeout(e);
                         var e = setTimeout(function() {

                             t.$video.play()
                         }, this._transitionDuration)
                     },
                     pauseVideo: function() {
                         //this.$video.pause()
                     }
                     ,

                     _onLoadMemberImage: function (t)
                     {
                         this.$imagesContainer[t].classList.remove("is-loading")
                     },
                     onOpenPopinCar: function (t, e)
                     {
                       this.forceRerender();
                       if(this.isButtonClicked)
                          return false;

                         var n = this;
                         this.popinIndex = 0,
                         this.popinContent = t,
                         this.popinTitle = t.title,
                         this.eventHub.$emit("disable:scroll"),
                         this.eventHub.$emit("open:popin"),
                         setTimeout(function ()
                         {
                             n.isPopinActive = !0,
                             n.$el.classList.add("is-popin-active"),
                             n.onTransition()
                         }, 50)
                     },
                     onOpenPopin: function (t, e)
                     {
                       this.forceRerender();
                       if(this.isButtonClicked)
                           return false;
                          alert("send data photo");
                         var n = this;
                         this.popinIndex = 0,
                         this.popinContent =t,
                         this.popinTitle = t.title,
                         this.eventHub.$emit("disable:scroll"),
                         this.eventHub.$emit("open:popin"),
                         setTimeout(function ()
                         {
                             n.isPopinActive = !0,
                             n.$el.classList.add("is-popin-active"),
                             n.onTransition()
                         }, 50)
                     },
                     onHoverPopin: function (t, e) {

                         var n = this;

                         var QselectHover = n.$el.querySelector("#hover"+t);
                         var QselectNormal = n.$el.querySelector("#"+t);

                         QselectNormal.classList.remove("fade-enter-active");
                         QselectHover.classList.remove("fade-leave-to");

                         QselectNormal.classList.add("fade-leave-to");
                         QselectHover.classList.add("fade-enter-active");

                     },
                     onHoverOutPopin: function (t, e)
                     {

                         var n = this;
                         var QselectHover = n.$el.querySelector("#hover"+t);
                         var QselectNormal = n.$el.querySelector("#"+t);
                         QselectNormal.classList.remove("fade-leave-to");
                         QselectHover.classList.remove("fade-enter-active");

                         QselectNormal.classList.add("fade-enter-active");
                         QselectHover.classList.add("fade-leave-to");
                     },
                     onClosePopin: function ()
                     {
                         this.eventHub.$emit("enable:scroll"),
                         this.isPopinActive = !1,
                         this.isBoardActive = !1,
                         this.$el.classList.remove("is-popin-active"),
                         this.onTransition()

                     },
                     onClosePopinCar: function ()
                     {
                         this.eventHub.$emit("enable:scroll"),
                         this.isPopinActive = !1,
                         this.isBoardActive = !1,
                         this.$el.classList.remove("is-popin-active"),
                         this.onTransition()

                     },
                     onOpenBoard: function(t)
                     {
                         var e = this;
                         t === this.content.subsidiaries_sections.length - 1 && (this.eventHub.$emit("disable:scroll"), this.eventHub.$emit("open:popin"),
                         setTimeout(function () {
                             e.isBoardActive = !0,
                             e.onTransition()
                         }, 50))
                     },
                     onTransition: function ()
                     {
                         var t = this;
                         this.$el.classList.add("is-switching"),
                         clearTimeout(this._timerTransition),
                         this._timerTransition = setTimeout(function () {
                             t.$el.classList.remove("is-switching")
                         }, 650)
                     }



                 }
}
</script>
